import React, { useCallback } from 'react';

import { ORDER_DIRECTION, OrderDirectionKey } from '../models/order-direction';
import { styled } from '../theme';
import { ActionIcon } from './ActionIcons';
import TableHeaderCell from './TableHeaderCell';

const HeaderContent = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
});

export interface TableSortHeaderProps {
    columnName: string;
    sortKey: string;
    params: {
        order_by?: string;
        order_direction?: OrderDirectionKey;
    };
    setSortOrder: (orderBy: string, orderDirection?: OrderDirectionKey) => void;
    toggleSortDirection: () => void;
    width?: string;
    style?: React.CSSProperties;
}

const TableSortHeader: React.FC<TableSortHeaderProps> = ({
    columnName,
    sortKey,
    params,
    setSortOrder,
    toggleSortDirection,
    width = 'auto',
    style = {},
}) => {
    const isActive = params.order_by === sortKey;

    const handleClick = useCallback(() => {
        isActive ? toggleSortDirection() : setSortOrder(sortKey, ORDER_DIRECTION.ASC);
    }, [toggleSortDirection, setSortOrder, sortKey, isActive]);

    return (
        <TableHeaderCell style={{ width, ...style }}>
            <HeaderContent onClick={handleClick}>
                {columnName}
                {isActive && (
                    <ActionIcon
                        src={
                            params.order_direction === ORDER_DIRECTION.DESC
                                ? '/icons/ic-sort-desc.svg'
                                : '/icons/ic-sort-asc.svg'
                        }
                    />
                )}
            </HeaderContent>
        </TableHeaderCell>
    );
};

export default TableSortHeader;
